export const timelineEvents = [
  {
    year: 1964,
    title: "Pølsevognen på Rutebilstationen",
    description: "Det hele startede som en lille københavnervogn med en ejer ved efternavn Jensen. Dette var begyndelsen på det, der senere skulle blive til den ikoniske Benny's Pølsevogn."
  },
  {
    year: 1999,
    title: "Bennys Pølsevogn Åbner",
    description: "Efter at have været drevet af Allan, overtager Benny pølsevognen og omdøber den til Benny's Pølsevogn. Med en vision om at skabe et stammiljø med fokus på kundepleje samt en humoristisk og hjemlig stemning, udvider han sortimentet med specialpølser, hjemmelavede dressinger og sandwiches."
  },
  {
    year: 2000,
    title: "Ny Varmestue",
    description: "Den lille og meget besøgte pølsevogn bliver udvidet med en omkringliggende 'varmestue' til stor glæde for alle kunderne."
  },
  {
    year: 2006,
    title: "Ny og Større Vogn",
    description: "Den oprindelige vogn erstattes med en ny og større vogn med helt nyt inventar. Her skabes mere plads til kunderne, den hjemlige stemning og alle de gode sladder- og vandrehistorier. Der etableres også et hyggeligt udendørsmiljø."
  },
  {
    year: 2013,
    title: "Brian Overtager Biksen",
    description: "Sønnen Brian overtager den succesfulde pølsevogn med ambitionen om at videreføre pølsevognen i farens ånd. Benny kan dog stadig ofte findes på sin faste plads i hjørnet, hvor han rundhåndet fyrer sjove jokes af."
  },
  {
    year: 2017,
    title: "Genopstandelsen",
    description: "Efter en brand genopstår Benny's Pølsevogn stærkere end nogensinde. Som Brian lovede, blev vognen hurtigt genopbygget - nu endnu smukkere og mere moderne, men stadig med den samme autentiske sjæl."
  },
  {
    year: 2019,
    title: "Fremtiden Kalder",
    description: "Med over et halvt århundredes erfaring og tre generationers kærlighed til den gode danske pølsevognskultur, ser vi frem mod nye eventyr. Traditionen, kvaliteten og den gode stemning fortsætter, mens vi udvikler os med tiden og vores trofaste kunders ønsker."
  }
];